// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__18E11","footer":"ModalUpdate_footer__5hZYM"};